module.exports = __webpack_public_path__ + "img/icon_report_playing.d6e947cf.gif";